import { Filter, UserAgent, UserAgentData } from './user-agent';

export default UserAgent;
export type { Filter, UserAgentData };
